import React from 'react'
import ListUnpushEmbroideryPage from './ListUnpushEmbroideryPage'
import '../styles/index.scss'

function ListUnpushEmbroideryContainer() {
    return (
        <div className='ListUnpushEmbroideryContainer'>
            <ListUnpushEmbroideryPage />
        </div>
    )
}

export default ListUnpushEmbroideryContainer